<script>
import Jobs from "@/components/jobs/Jobs.vue";
import SearchJob from "@/components/jobs/SearchJob.vue";
//Components
import LeLisBlang from "./LeLisBlang.vue";
import Dudalina from "./Dudalina.vue";
import JohnJohn from "./JohnJohn.vue";
import Bobo from "./Bobo.vue";
import RosaCha from "./RosaCha.vue";
import Individual from "./Individual.vue";
import Corporativas from "./Corporativas.vue";
import Lojas from "./Lojas.vue";
import Industria from "./Industria.vue";
import Geral from "./Geral.vue";

export default {
  name: "JobsList",
  data() {
    return {
      componentId: null,
      search: "",
      syncdSearch: "",
    };
  },
  head() {
    return this.$head({
      title: "Vagas | ",
    });
  },
  watch: {
    "$route.params.group": function (group) {
      this.getGroup();
    },
  },
  mounted() {
    this.getGroup();
  },
  methods: {
    getGroup() {
      if (this.group == "le-lis-blang") {
        this.componentId = "LeLisBlang";
      }
      if (this.group == "john-john") {
        this.componentId = "JohnJohn";
      }
      if (this.group == "bobo") {
        this.componentId = "Bobo";
      }
      if (this.group == "rosa-cha") {
        this.componentId = "RosaCha";
      }
      if (this.group == "individual") {
        this.componentId = "Individual";
      }
      if (this.group == "dudalina") {
        this.componentId = "Dudalina";
      }
      if (this.group == "corporativas") {
        this.componentId = "Corporativas";
      }
      if (this.group == "industria") {
        this.componentId = "Industria";
      }
      if (this.group == "geral") {
        this.componentId = "Geral";
      }
      if (this.group == "lojas") {
        this.componentId = "Lojas";
      }
    },
  },
  props: {
    group: null,
  },
  components: {
    Jobs,
    SearchJob,
    LeLisBlang,
    Dudalina,
    JohnJohn,
    Bobo,
    RosaCha,
    Individual,
    Corporativas,
    Industria,
    Geral,
    Lojas,
  },
};
</script>

<template>
  <div class="jobs-group">
    <div class="banner" :class="group">
      <img
        v-if="componentId == 'LeLisBlang'"
        data-aos="fade-down"
        data-aos-duration="1000"
        class="logo"
        src="@/assets/images/restoque/lelisblang-w.png"
        alt=""
      />
      <img
        v-if="componentId == 'Dudalina'"
        data-aos="fade-down"
        data-aos-duration="1000"
        class="logo"
        src="@/assets/images/restoque/dudalina-w.png"
        alt=""
      />
      <img
        v-if="componentId == 'JohnJohn'"
        data-aos="fade-down"
        data-aos-duration="1000"
        class="logo"
        src="@/assets/images/restoque/John_John-w.png"
        alt=""
      />
      <img
        v-if="componentId == 'Bobo'"
        data-aos="fade-down"
        data-aos-duration="1000"
        class="logo"
        src="@/assets/images/restoque/bobo-w.png"
        alt=""
      />
      <img
        v-if="componentId == 'RosaCha'"
        data-aos="fade-down"
        data-aos-duration="1000"
        class="logo"
        style="width: 300px"
        src="@/assets/images/restoque/rosa_cha-w.png"
        alt=""
      />
      <img
        v-if="componentId == 'Individual'"
        data-aos="fade-down"
        data-aos-duration="1000"
        class="logo"
        src="@/assets/images/restoque/individual-w.png"
        alt=""
      />
      <h1 v-if="componentId == 'Corporativas'">vagas corporativas</h1>
      <h1 v-if="componentId == 'Lojas'">Vagas em lojas</h1>
      <h1 v-if="componentId == 'Industria'">
        Vagas nas Indústrias <br />
        e nos Centros Logísticos
      </h1>
      <div
        class="search d-flex justify-content-center align-items-center"
        data-aos="fade-up"
        data-aos-duration="1000"
      >
        <input
          type="text"
          placeholder="digite o nome da vaga"
          v-model="search"
          @keypress.enter="syncdSearch = search"
        />
        <button @click="syncdSearch = search">
          &nbsp; <img src="@/assets/images/search.svg" alt="" />
        </button>
      </div>
    </div>
    <component :is="componentId"></component>
    <Jobs :search.sync="syncdSearch" />
  </div>
</template>


<style lang="scss" scoped>
h1 {
  color: #fff;
  font-size: 3rem;
  z-index: 99;
  text-transform: uppercase;
  font-weight: 400;
  text-align: center;
}
.jobs-group {
  .banner {
    width: 100%;
    height: 70vh;
    .search {
      width: 90%;
      max-width: 800px;
      border-radius: 100px;
      margin: 0 auto;
      margin-top: 1.7rem;
      z-index: 99;
      input {
        height: 70px;
        box-sizing: border-box;
        width: calc(100% - 8rem);
        background-color: rgba(#fff, 0.8);
        border-radius: 4px;
        border: none;
        font-size: 1.8rem;
        padding: 0px 1rem 0px 2rem;
        &::-webkit-input-placeholder {
          /* Chrome/Opera/Safari */
          color: rgba(#000, 0.45);
        }
        &::-moz-placeholder {
          /* Firefox 19+ */
          color: rgba(#000, 0.45);
        }
        &:-ms-input-placeholder {
          /* IE 10+ */
          color: rgba(#000, 0.45);
        }
        &:-moz-placeholder {
          /* Firefox 18- */
          color: rgba(#000, 0.45);
        }
        @include media-breakpoint-down(sm) {
          height: 40px;
          box-sizing: border-box;
          width: 100%;
          padding-right: 3rem;
          font-size: 1.2rem;
        }
      }
      button {
        padding: 0px;
        background-color: transparent;
        border: transparent;
        width: 4rem;
        margin-left: -4.3rem;
        img {
          width: 2rem;
        }
      }
    }
    &.le-lis-blang {
      background: url(../../assets/images/restoque/bg-le-lis-blang.jpg)
        no-repeat center center;
      background-size: cover;
      position: relative;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      img.logo {
        position: relative;
        z-index: 99;
        width: 70%;
        max-width: 400px;
        margin-top: 3rem;
        margin-bottom: 1rem;
      }
      &::after {
        content: "";
        left: 0;
        top: 0;
        position: absolute;
        width: 100%;
        height: 100%;
        z-index: 1;
        background-color: rgba(#000, 0.5);
      }
    }
    &.dudalina {
      background: url(../../assets/images/restoque/dudalina.jpg) no-repeat
        center center;
      background-size: cover;
      position: relative;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      img.logo {
        position: relative;
        z-index: 99;
        width: 70%;
        max-width: 400px;
        margin-top: 3rem;
        margin-bottom: 1rem;
      }
      &::after {
        content: "";
        left: 0;
        top: 0;
        position: absolute;
        width: 100%;
        height: 100%;
        z-index: 1;
        background-color: rgba(#000, 0.5);
      }
    }
    &.john-john {
      background: url(../../assets/images/restoque/johnjohn.jpg) no-repeat
        center center;
      background-size: cover;
      position: relative;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      img.logo {
        position: relative;
        z-index: 99;
        width: 70%;
        max-width: 400px;
        margin-top: 3rem;
        margin-bottom: 1rem;
      }
      &::after {
        content: "";
        left: 0;
        top: 0;
        position: absolute;
        width: 100%;
        height: 100%;
        z-index: 1;
        background-color: rgba(#000, 0.5);
      }
    }
    &.bobo {
      background: url(../../assets/images/restoque/bobo.jpg) no-repeat center
        center;
      background-size: cover;
      position: relative;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      img.logo {
        position: relative;
        z-index: 99;
        width: 70%;
        max-width: 400px;
        margin-top: 3rem;
        margin-bottom: 1rem;
      }
      &::after {
        content: "";
        left: 0;
        top: 0;
        position: absolute;
        width: 100%;
        height: 100%;
        z-index: 1;
        background-color: rgba(#000, 0.5);
      }
    }
    &.rosa-cha {
      background: url(../../assets/images/restoque/rosacha.jpg) no-repeat center
        center;
      background-size: cover;
      position: relative;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      img.logo {
        position: relative;
        z-index: 99;
        width: 70%;
        max-width: 400px;
        margin-top: 3rem;
        margin-bottom: 1rem;
      }
      &::after {
        content: "";
        left: 0;
        top: 0;
        position: absolute;
        width: 100%;
        height: 100%;
        z-index: 1;
        background-color: rgba(#000, 0.5);
      }
    }
    &.individual {
      background: url(../../assets/images/restoque/individual.jpg) no-repeat
        center center;
      background-size: cover;
      position: relative;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      img.logo {
        position: relative;
        z-index: 99;
        width: 70%;
        max-width: 400px;
        margin-top: 3rem;
        margin-bottom: 1rem;
      }
      &::after {
        content: "";
        left: 0;
        top: 0;
        position: absolute;
        width: 100%;
        height: 100%;
        z-index: 1;
        background-color: rgba(#000, 0.5);
      }
    }
    &.corporativas {
      background: url(../../assets/images/restoque/corporativas.jpg) no-repeat
        center center;
      background-size: cover;
      position: relative;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      img.logo {
        position: relative;
        z-index: 99;
        width: 70%;
        max-width: 400px;
        margin-top: 3rem;
        margin-bottom: 1rem;
      }
      &::after {
        content: "";
        left: 0;
        top: 0;
        position: absolute;
        width: 100%;
        height: 100%;
        z-index: 1;
        background-color: rgba(#000, 0.5);
      }
    }
    &.lojas {
      background: url(../../assets/images/restoque/loja.jpg) no-repeat center
        center;
      background-size: cover;
      position: relative;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      img.logo {
        position: relative;
        z-index: 99;
        width: 70%;
        max-width: 400px;
        margin-top: 3rem;
        margin-bottom: 1rem;
      }
      &::after {
        content: "";
        left: 0;
        top: 0;
        position: absolute;
        width: 100%;
        height: 100%;
        z-index: 1;
        background-color: rgba(#000, 0.5);
      }
    }
    &.industria {
      background: url(../../assets/images/restoque/industria.jpg) no-repeat
        center center;
      background-size: cover;
      position: relative;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      img.logo {
        position: relative;
        z-index: 99;
        width: 70%;
        max-width: 400px;
        margin-top: 3rem;
        margin-bottom: 1rem;
      }
      &::after {
        content: "";
        left: 0;
        top: 0;
        position: absolute;
        width: 100%;
        height: 100%;
        z-index: 1;
        background-color: rgba(#000, 0.5);
      }
    }
    &.geral {
      position: relative;
      display: none;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      img.logo {
        position: relative;
        z-index: 99;
        width: 70%;
        max-width: 400px;
        margin-top: 3rem;
        margin-bottom: 1rem;
      }
      &::after {
        content: "";
        left: 0;
        top: 0;
        position: absolute;
        width: 100%;
        height: 100%;
        z-index: 1;
        background-color: rgba(#000, 0.5);
      }
    }
  }
}
</style>